






import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'
import mixin from './mixin'

@Component({
	name: 'LinkTaskDetail',
	components: {},
})
export default class commonDetail extends Mixins(mixin) {}
